import React from 'react';
import { ArrowUpRight, Wifi, Globe2, Zap } from 'lucide-react';
import DigitalGlobe from './DigitalGlobe';
import Reveal from './Reveal';

export default function DigitalWorld() {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 md:py-32 bg-[#0f1620] text-white overflow-hidden">
      {/* Soft gradients */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-20 w-[500px] h-[500px] rounded-full bg-[#1e6cb0]/20 blur-3xl" />
        <div className="absolute -bottom-40 -right-10 w-[500px] h-[500px] rounded-full bg-[#5eb0e8]/10 blur-3xl" />
      </div>

      {/* Grid texture */}
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(#5eb0e8 1px, transparent 1px), linear-gradient(90deg, #5eb0e8 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: text */}
          <div className="lg:col-span-5">
            <Reveal variant="left" delay={50}>
              <div className="inline-flex items-center gap-2 mb-6">
                <span className="w-8 h-px bg-[#5eb0e8]" />
                <span className="text-[12px] tracking-[0.2em] font-semibold text-[#5eb0e8] uppercase">
                  Mondo digitale
                </span>
              </div>
            </Reveal>

            <Reveal as="h2" variant="up" delay={150} duration={900} className="heading-mega text-[40px] sm:text-[54px] md:text-[64px] text-white">
              Connessi<br />
              al <span className="text-[#5eb0e8]">mondo.</span><br />
              Radicati a Biella.
            </Reveal>

            <Reveal as="p" variant="up" delay={300} className="mt-6 text-[16px] leading-relaxed text-white/70 max-w-md">
              Lavoriamo con tecnologie che muovono il web di oggi: server veloci, sicurezza al top,
              integrazioni con i servizi che gi&agrave; usi. Tutto pensato per portare il tuo business online
              senza complicazioni.
            </Reveal>

            <div className="mt-8 grid grid-cols-3 gap-3 max-w-md">
              {[
                { icon: Wifi, label: 'Sempre online', sub: '99,9% uptime' },
                { icon: Globe2, label: 'CDN globale', sub: 'Veloce ovunque' },
                { icon: Zap, label: 'Performance', sub: 'Caricamento istant.' },
              ].map((it, i) => (
                <Reveal key={it.label} variant="up" delay={400 + i * 100} duration={700}>
                  <div className="p-3.5 rounded-2xl bg-white/[0.04] border border-white/10 hover:border-[#5eb0e8]/40 transition-colors h-full">
                    <it.icon className="w-4 h-4 text-[#5eb0e8] mb-2" />
                    <div className="text-[12px] font-bold text-white leading-tight">{it.label}</div>
                    <div className="text-[10px] text-white/50 mt-0.5 leading-tight">{it.sub}</div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal variant="up" delay={750}>
              <a
                href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20portare%20online%20la%20mia%20azienda."
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 bg-[#1e6cb0] hover:bg-[#2479c4] text-white px-7 py-4 rounded-full font-semibold transition-colors"
              >
                Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
              </a>
            </Reveal>
          </div>

          {/* Right: globe */}
          <Reveal variant="scale" delay={200} duration={1100} className="lg:col-span-7 flex justify-center w-full">
            <div className="w-full max-w-[520px] aspect-square">
              <DigitalGlobe size="100%" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
